import React from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';

export const ToggleButton = (
  props: {
    isOpen: boolean;
    onToggle: () => void;
  } & IconButtonProps
) => {
  const { isOpen, onToggle, sx } = props;

  return (
    <IconButton
      size="small"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle();
      }}
      sx={{ ml: -1, mr: 1, ...sx }}
    >
      <KeyboardArrowDown
        sx={{
          color: 'secondary.light',
          ...(isOpen && { transform: 'rotate(180deg)' }),
        }}
      />
    </IconButton>
  );
};
